import { buildUrl } from 'domain/Api';
import { createApiActionCreator } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'NOTIFICATIONS';

export const FETCH_NOTIFICATIONS_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_NOTIFICATIONS_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_NOTIFICATIONS_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;
export const SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS = 'SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS';

const createNotificationsActionCreators =
    createApiActionCreator(
      ACTION_OBJECT_NAME, buildUrl('/users/my-notifications'));

export const fetchNotifications = createNotificationsActionCreators;



// WEBPACK FOOTER //
// ./data/Users/Notifications/actions.js